import React from "react";
import { useNavigate } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useCmsList } from "../hooks";

export const CmsList: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useCmsList();

  return (
    <>
      <Header
        title="CMS"
        subtitle="Référentiel des CMS utilisés par les clients"
        buttons={[
          {
            actionText: "Nouveau CMS",
            bgColor: "indigo",
            textColor: "white",
            link: `/cms-item/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.cmsList?.results?.length ? (
            <EmptyList text="Aucun CMS" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.cmsList?.results?.map((cms) => (
                  <TableRow
                    key={`cms-${cms.id}`}
                    onClick={() => navigate(`/cms-item/${cms.id}/update`)}
                  >
                    <TableCell>{cms.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
